export default {
  initialize(owner) {
    owner.lookup("service:route-scroll-manager");
  },
};
